export default __webpack_public_path__ + "static/media/INACTIVE.2e242ffb.png";